import React, { useContext } from 'react';
import { Tooltip } from 'antd';
import { TimelineSvg, EditorSvg } from '../svgs';
import { ThemeContext } from '../../../../../pages/_app';
import styles from './editor-switcher.module.css';

interface EditorSwitcherProps {
  isTimelineMode: boolean;
  onTimelineClick: () => void;
  onEditorClick: () => void;
}

const EditorSwitcher: React.FC<EditorSwitcherProps> = ({
  isTimelineMode,
  onTimelineClick,
  onEditorClick,
}) => {
  const { isDark } = useContext(ThemeContext);

  return (
    <div className={styles.editorSwitcher}>
      <div className={styles.switcherContainer}>
        <Tooltip title='Scene Editor'>
          <button
            className={`${styles.switcherButton} ${
              !isTimelineMode ? styles.active : ''
            } ${isDark ? styles.dark : ''}`}
            onClick={onEditorClick}
          >
            {EditorSvg}
          </button>
        </Tooltip>
        <Tooltip title='Timeline Node Manager'>
          <button
            className={`${styles.switcherButton} ${
              isTimelineMode ? styles.active : ''
            } ${isDark ? styles.dark : ''}`}
            onClick={onTimelineClick}
          >
            {TimelineSvg}
          </button>
        </Tooltip>
      </div>
    </div>
  );
};

export default EditorSwitcher;
